/**
 * Lease permission codes (FIN-FR-021, `internal/lease/permissions.go`).
 *
 * Each is the permission its route declares (`internal/lease/handler.go`):
 *
 *   GET   /lease-contracts, /lease-contracts/:id, …/schedule, …/schedule-versions,
 *         …/changes, /reports/lease-*, /lease-runs              lease.contract.read
 *   POST  /lease-contracts, PATCH /lease-contracts/:id,
 *         POST /lease-contracts/:id/submit                     lease.contract.manage
 *   POST  /lease-contracts/:id/remeasure                       lease.contract.remeasure
 *   POST  /lease-contracts/:id/terminate                       lease.contract.terminate
 *   POST  /lease-runs                                          lease.run.post
 *
 * `lease.contract.approve` is held by the second person who decides a lease.contract,
 * lease.remeasurement or lease.termination task in the Approvals Inbox. There is no
 * activate route: approval is the activation.
 *
 * Every route is entitled under the plan module "assets" (a right-of-use asset is an asset).
 */
export const LEASE_PERMISSIONS = {
  read: 'lease.contract.read',
  manage: 'lease.contract.manage',
  approve: 'lease.contract.approve',
  remeasure: 'lease.contract.remeasure',
  terminate: 'lease.contract.terminate',
  runPost: 'lease.run.post',
} as const

/** The approvals doc types this module owns (`internal/lease/events.go`). */
export const LEASE_DOC_TYPES = {
  contract: 'lease.contract',
  remeasurement: 'lease.remeasurement',
  termination: 'lease.termination',
} as const
